import React, { Component } from "react";
import { connect } from "react-redux";
import InputComponent from "../../components/form/InputComponent";
import SelectComponent from "../../components/form/SelectComponent";
import { StyleSheet, css } from "aphrodite";
import SearchIcon from "@material-ui/icons/Search";
import {
  getTrainingListPending,
  getTrainingList,
  getTrainingListError,
} from "../../reducers/master-data/training_reducer";
import Button from "@material-ui/core/Button";
import ModalAddPelatihan from "./Modal_add_pelatihan";
import AddIcon from "@material-ui/icons/Add";
import _ from "lodash";
import { listHeaderStyles as shared } from "../../components/header/listHeaderStyles";

class HeaderPelatihan extends Component {
  constructor(props) {
    super(props);
    this.state = {
      search: "",
      status: "",
      modalAddPelatihanShow: false,
    };
    this.handleChangeSearch = this.handleChangeSearch.bind(this);
    this.handleChangeStatus = this.handleChangeStatus.bind(this);
    this.handleRefresh = this.handleRefresh.bind(this);
  }

  delayedQuery = _.debounce((value) => {
    this.props.handleRefresh(value);
  }, 500);

  handleChangeSearch(e) {
    if (e !== null) {
      this.setState({ search: e.target.value });
      this.delayedQuery({ search: e.target.value });
    }
  }

  handleChangeStatus(e) {
    if (e !== null) {
      this.setState({ status: e.value });
      this.props.handleRefresh({ status: e.value });
    } else {
      this.props.handleRefresh({ status: "" });
    }
  }

  handleRefresh(state) {
    this.props.handleRefresh(state);
  }

  render() {
    const { modalAddPelatihanShow } = this.state;
    const statusOption = [
      { value: 0, label: "Baru" },
      { value: 1, label: "Terverifikasi" },
      { value: 2, label: "Ditolak" },
    ];

    return (
      <div className={css(shared.bar)}>
        <ModalAddPelatihan
          show={modalAddPelatihanShow}
          onHide={() =>
            this.setState({ modalAddPelatihanShow: false })
          }
          handleRefresh={this.handleRefresh}
        />
        <div className={css(shared.title)}>
          <Button
            variant="contained"
            color="primary"
            className={css(styles.approveButton, shared.buttonFull)}
            startIcon={<AddIcon />}
            onClick={() =>
              this.setState({ modalAddPelatihanShow: true })
            }
          >
            Tambah Pelatihan
          </Button>
        </div>
        <div className={css(shared.actions)}>
          <div className={css(shared.field)}>
            <InputComponent
              onChange={this.handleChangeSearch}
              value={this.state.search}
              placeholder="Cari Nama Institusi"
              startIcon={SearchIcon}
              id="search"
            />
          </div>
          <div className={css(shared.field)}>
            <SelectComponent
              onChange={this.handleChangeStatus}
              placeholder="Status"
              options={statusOption}
              id="status"
            />
          </div>
        </div>
      </div>
    );
  }
}

const styles = StyleSheet.create({
  approveButton: {
    background: "#2CB96A 0% 0% no-repeat padding-box",
    boxShadow: "none",
  },
});

function mapStateToProps({ trainingList }) {
  return {
    trainingList_pending: getTrainingListPending(trainingList),
    trainingList_data: getTrainingList(trainingList),
    trainingList_error: getTrainingListError(trainingList),
  };
}

export default connect(mapStateToProps)(HeaderPelatihan);
